import { gsap } from "gsap";
import { GSDevTools } from "gsap/GSDevTools";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { SplitText } from "gsap/all";


import Experience from "../Experience";



// Register the plugin
gsap.registerPlugin(
    MotionPathPlugin,
    GSDevTools,
    DrawSVGPlugin,
    SplitText
);



export default class Animation {
    constructor() {

        this.experience = new Experience()
        this.resources = this.experience.resources
        this.backgroundParticle = this.experience.world.gParticles;
        this.canvas = document.querySelector(".webgl")



        this.isSmall = window.innerWidth < 700 ? 0 : -30

        this.title = document.querySelector(".title")
        gsap.set(this.title, { yPercent: 45 })

        this.titleSmall = document.querySelector(".title--small")
        gsap.set(this.titleSmall, { scale: 1, y:-30 })
        this.titleAnimationText = document.querySelector(".title__animation");
        this.splitText = new SplitText(this.titleAnimationText, { type: 'words', wordsClass: 'titleText' })

        this.section2 = document.querySelector(".section2")
        gsap.set(this.section2, { opacity: 0, autoAlpha: 0, scale: 0.5 })

        gsap.set(this.splitText.words, { yPercent: 100 }) 
        gsap.set(".section3", { scale: 0.5 })

        this.isPortrait = window.innerWidth <= 992

        gsap.set("#vedge", { yPercent: 10, opacity: 0 })
        gsap.set("#vedgestroke", { drawSVG: '100% 100%' })
        // gsap.set(["#bars > *"], { yPercent: 100, opacity: 0, transformOrigin: "50% 50%" })
        gsap.set(["#bars > g"], { yPercent: 110, opacity: 0})


        this.exploreButton = document.querySelector(".button__explore")
        this.preloadTl = gsap.timeline({
            paused: true, onComplete: () => {
                // this.preloadElement.parentElement.removeChild(this.preloadElement)
            }
        })
        this.setAnimation()


    }

    setAnimation() {




        // this.preloadTl.to(pl, {
        //   progress: 1, duration: 5, onComplete: () => {
        //     this.textRevealAnimation()
        //   }
        // })



        this.resources.on("experienceStart", (tl) => {
            this.textRevealAnimation(tl)

        })

        // this.preloadTl.play()
        // this.preloadTl.progress(0.5)

    }

    textRevealAnimation(tl) {
        this.counterText = document.querySelector(".text-number")
        this.preloadElement = document.querySelector(".experience .preload")

        this.counterText.initialValue = 0
        this.preloadTl.pause()


        this.enterTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                duration: 1.25
            },

        })
            .to(this.title, { yPercent: this.isSmall, }, 0)
            .to(this.titleSmall, { scale: this.isPortrait ? 0.6 : 0.3, y: this.isPortrait ? 15 : 30 }, 0)
            .to(this.splitText.words, { scale: 1, yPercent: 0, opacity: 1, stagger: 0.2 }, 0.2)
            .to(this.splitText.words, { clipPath: "polygon(0% 0%, 100% 0%, 100% 120%, 0% 120%)", opacity: 1, stagger: 0.2 }, 0.2)
            .to("#bars", { opacity: 1, scale: 0.9, transformOrigin: "center bottom" }, 2)
            .to(["#bars > g"], { yPercent: 0, opacity: 1, stagger: 0.1, }, 2.5)
            .to("#vedge", { yPercent: 10, opacity: 1, ease: 'back' }, 2.5)
            .to("#vedgestroke", { drawSVG: '0% 100%', duration: 3, ease: 'linear' }, 1.5)

            .to("#vedgearrow", {
                motionPath: { path: '#vedgestroke', align: "#vedgestroke", alignOrigin: [0.2, 0.5], autoRotate: true, start: 1, end: 0 },
                duration: 3, ease: 'linear'
            }, 1.5) 

            .to("#vedgearrow", { opacity: 0, duration: 0.5 }, 4.2)
            .to(this.preloadElement, { scale: 2, opacity: 0, autoAlpha: 0, duration: 0.75, ease: 'power4.inOut' }, 0)
            .to(this.backgroundParticle.bgTl, { ease: 'power4', progress: 1, duration: 5 }, 0.5)
            .to(".button--primary", { y: 0, duration: 1, ease: 'power4.inOut' }, 5)
            // ADD HEADER ANIMATION
            .to('.header', {opacity:1, duration: 1,top: 0, ease: 'power4.inOut' }, 5)
            .addPause()
            .addLabel('section2')
            .to(this.experience.world.earthSphere.sphere.material.uniforms.uAlpha, {value:1.0}, 'section2')
            .to(".section1, .section1 > *", { scale: 1.4, opacity: 0, autoAlpha: 0, stagger: 0.2 }, 'section2')
            .to(this.section2, { opacity: 1, autoAlpha: 1, scale: 1 }, 'section2')
            .from(".section2 .section__container > div", { duration: 2, xPercent: gsap.utils.wrap([-20, 0, 20]), autoAlpha: 0, opacity: 0, stagger: 0.2 }, 'section2')
            .addPause()
            .addLabel('section3')
            .to(this.experience.world.earthSphere.sphere.material.uniforms.uAlpha, {value:0.0, duration: 0.5}, 'section3')
            .to(this.section2, { opacity: 0, autoAlpha: 0, scale: 1.5 }, 'section3')
            .to(".section3", { opacity: 1, autoAlpha: 1, scale: 1 }, 'section3')
            .to(this.experience, { intManUpdate: true }, 'section3+=1.5')
            .to(this.experience.world.earthSphere, { timeDuration: 2 })
            .from(this.experience.world.intPlane.interactiveGroup.position, { z: -200, duration: 0.25 }, 'section3')





        // interactive buttons
        this.exploreButton.addEventListener("click", () => {
            this.experience.world.earthSphere.timeDuration = 2.5;
            this.experience.camera.cameraPosition = 60
            gsap.to(this.experience.camera.instance.position, { x: 0, y: 0, z: this.experience.camera.cameraPosition, duration: 2 })
            this.experience.world.earthSphere.particles.morph2()
            this.experience.camera.controls.autoRotate = true
            this.experience.camera.controls.enablePan = false

            gsap.to(this.enterTl, { progress: 0.65, duration: 3, ease: 'power1.inOut' })

        })

    }

    countryScoreCard() {
        this.experience.world.earthSphere.timeDuration = 2.5;
        this.experience.world.earthSphere.particles.morph1()
        this.experience.world.intPlane.interactiveGroup.visible = true;

        gsap.to(this.experience.world.intPlane.shaderMaterial.uniforms.uTransparent, { value: 1, duration: 2, delay: 1 })
        gsap.to(this.experience.camera.instance.position, { x: 0, y: 0, z: this.experience.camera.cameraPosition, duration: 1.4, ease: 'linear', delay: 0.5 })
        gsap.to(this.enterTl, { progress: 1, duration: 3, ease: 'power0' })
        this.experience.camera.controls.autoRotate = false
        this.experience.camera.controls.enablePan = true
    }
    
    navigateToCountryScoreCard() {
        const progress = this.enterTl.progress()
        if (progress > 0.6) {
            this.countryScoreCard()
        } else {
            gsap.to(".experience", { opacity: 0, duration: 0.25, ease: 'linear' })
                .then(() => {
                    this.enterTl.progress(1.0)
                    this.countryScoreCard()
                }).then(() => {
                    gsap.to(".experience", { opacity: 1, duration: 0.25, ease: 'linear' })
                })

        }
    }

}